import { useState } from 'react';
import { BlockButton } from '@/components/BlockButton';
import { useAtom } from 'jotai';
import { currentSelectjobChangeProcessLogStatusAtom } from '../../atoms/jobChangeProcess';
import useDeleteJobChangeProcess from '../../api/useDeleteJobChangeProcess';
import { showErrorToast, showSuccessToast } from '../../lib/toast';
type Props = {
  close: () => void;
  jobchangeProcessesRefetch: () => Promise<void>;
};

export default function LogDeleteConfirmModalContents({ close, jobchangeProcessesRefetch }: Props) {
  const [isSubmit, setIsSubmit] = useState(false);
  const [currentSelectjobChangeProcessLogStatus, setCurrentSelectjobChangeProcessLogStatus] =
    useAtom(currentSelectjobChangeProcessLogStatusAtom);
  const { mutateAsync } = useDeleteJobChangeProcess();

  const onSubmit = async () => {
    setIsSubmit(true);
    try {
      await mutateAsync({
        jobChangeProcessId: currentSelectjobChangeProcessLogStatus!.jobChangeProcessId,
        latestLogId: currentSelectjobChangeProcessLogStatus!.latestLogId,
        result: currentSelectjobChangeProcessLogStatus!.result,
        interviewed_at: new Date(currentSelectjobChangeProcessLogStatus!.interviewedAt ?? ''),
      });
      showSuccessToast('削除しました');
    } catch (error) {
      showErrorToast('削除に失敗しました');
    } finally {
      setCurrentSelectjobChangeProcessLogStatus(null);
      setIsSubmit(false);
      await currentSelectjobChangeProcessLogStatus!.refetch();
      await jobchangeProcessesRefetch();
      close();
    }
  };

  return (
    <div className="w-[640px] bg-white">
      <div className="px-6 py-4">
        <p className="text-base font-bold">変更の確認</p>
      </div>
      <div className="border-y border-solid border-border px-6 py-4">
        <p className="text-base">削除しますか？</p>
      </div>
      <div className="flex justify-end gap-4 px-6 py-4">
        <div className="w-[94px]">
          <BlockButton
            disabled={isSubmit}
            colorType="white"
            type="button"
            text="キャンセル"
            onClick={close}
          />
        </div>
        <div className="w-[52px]">
          <BlockButton
            disabled={isSubmit}
            colorType="red"
            type="button"
            text="削除"
            onClick={onSubmit}
          />
        </div>
      </div>
    </div>
  );
}
